import { batch } from 'react-redux';

import { setPrevStep, setStep } from '~/src/features/full-buy/store/actions';
import { TDispatch, TGetState } from '~/src/store';

export const goToNextStep = () => (dispatch: TDispatch, getState: TGetState) => {
    const state = getState().fullBuy;

    const {
        stepIndex,
        flow,
    } = state;

    if (!flow) {
        return;
    }

    const newIndex = stepIndex + 1;

    if (newIndex <= flow.steps.length) {
        batch(() => {
            dispatch(setPrevStep(stepIndex));
            dispatch(setStep(newIndex));
        });
    }
};
